import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import Api from "@/services/api"
    import { Video } from "@/services/types"
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus"
    import { nextTick, onBeforeMount, reactive, ref } from "vue"
    import { useStore } from "vuex"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateVideo',
  setup(__props) {

    const store = useStore()
    const video = reactive<Video>({
        title: '',
        description: '',
        path: undefined,
        video: undefined
    })

    const rules = reactive<FormRules<Video>>({
        title: [{required: true, message: 'Insira o título do vídeo', min: 1}],
        description: [{required: true, message: 'Informe a descrição'}],
        video: [{required: true, message: 'adicione o vídeo'}]
    })

    const saving = ref<boolean>(false)
    const file = ref<string>()
    const videoFile = ref()
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(true)
    const prev = ref<HTMLVideoElement>()
   
    onBeforeMount(async () => {
        loading.value = false
    })


    const selectVideo = async () => {
        // verificar se e um video valido
        if (file.value && /\.(mp4|avi|webm)$/.test(file.value)) {
            console.log("Mudou o video 2")
            video.video = videoFile.value?.input.files[0]
            video.path = videoFile.value?.input.files[0] ? URL.createObjectURL(videoFile.value?.input.files[0]):undefined
            prev.value?.load()
        } else {
            ElMessage.error("Formato de ficheiro incorreto, escolha um vídeo com os formatos .mp4, .webm ou .avi")
            file.value = undefined
        }
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                if (!video.video) {
                    ElMessageBox.alert('Adicione o vídeo')
                    return
                }
                saving.value = true
                const data = new FormData()
                data.append('title', video.title)
                data.append('description', video.description)
                data.append('video', video.video)
                
                const res = await Api.post('admin/videos', video, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Video cadastrado com sucesso'})
                    store.commit('setOpenModal', -1)
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    rows: 12,
    loading: loading.value,
    animated: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        disabled: saving.value,
        rules: rules,
        model: video,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "title",
            label: "Título do vídeo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                name: "title",
                type: "text",
                modelValue: video.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((video.title) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "Adicione o vídeo" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: file.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((file).value = $event)),
                type: "file",
                ref_key: "videoFile",
                ref: videoFile,
                name: "video",
                onChange: selectVideo
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (video.path)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                ref_key: "prev",
                ref: prev,
                controls: "",
                style: {width: '100%'}
              }, [
                _createElementVNode("source", {
                  src: video.path
                }, null, 8, _hoisted_1)
              ], 512))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "Descrição",
            prop: "description"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                name: "description",
                modelValue: video.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((video.description) = $event)),
                minlength: "1"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            plain: "",
            loading: saving.value,
            size: "large",
            type: "primary",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Cadastrar ", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["disabled", "rules", "model"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})